// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiCreateDropPart } from '../models/ApiCreateDropPart';
import { ApiCreateMentionedWave } from '../models/ApiCreateMentionedWave';
import { ApiDropMentionedUser } from '../models/ApiDropMentionedUser';
import { ApiDropMetadata } from '../models/ApiDropMetadata';
import { ApiDropReferencedNFT } from '../models/ApiDropReferencedNFT';
import { HttpFile } from '../http/http';

export class ApiUpdateDropRequest {
    'mentions_all'?: boolean;
    'title'?: string | null;
    'parts': Array<ApiCreateDropPart>;
    'referenced_nfts': Array<ApiDropReferencedNFT>;
    'mentioned_users': Array<ApiDropMentionedUser>;
    'mentioned_waves'?: Array<ApiCreateMentionedWave>;
    'metadata': Array<ApiDropMetadata>;
    /**
    * If wave requires drop signatures then this needs to be set. Signature of a drop is ethSign(creatorWallet, sha256(oneLineJsonWithAlphabeticallySortedFieldsRecursive(ApiCreateDropRequest - signature (+ wave.participation.terms if it exists))))
    */
    'signature': string | null;
    'is_safe_signature'?: boolean;
    'signer_address'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "mentions_all",
            "baseName": "mentions_all",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "parts",
            "baseName": "parts",
            "type": "Array<ApiCreateDropPart>",
            "format": ""
        },
        {
            "name": "referenced_nfts",
            "baseName": "referenced_nfts",
            "type": "Array<ApiDropReferencedNFT>",
            "format": ""
        },
        {
            "name": "mentioned_users",
            "baseName": "mentioned_users",
            "type": "Array<ApiDropMentionedUser>",
            "format": ""
        },
        {
            "name": "mentioned_waves",
            "baseName": "mentioned_waves",
            "type": "Array<ApiCreateMentionedWave>",
            "format": ""
        },
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "Array<ApiDropMetadata>",
            "format": ""
        },
        {
            "name": "signature",
            "baseName": "signature",
            "type": "string",
            "format": ""
        },
        {
            "name": "is_safe_signature",
            "baseName": "is_safe_signature",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "signer_address",
            "baseName": "signer_address",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiUpdateDropRequest.attributeTypeMap;
    }

    public constructor() {
    }
}
